<template>
  <img
    :src="getImgUrl(this.model)"
    :alt="this.altText"
    :id="this.id ?? this.src"
    :class="this.class"
      
  />
</template>

<script>
import { brandCrest } from "../../constants/labels.config";
export default {
  name: "DefaultImage",
  props: ["model", "altText", "class", "id"],
  methods: {
      getImgUrl(model) {
        var retVal = "";
        if (window.BRAND.toLowerCase() != brandCrest.toLowerCase()) {
            retVal = "/img/brand/MasterCraft/MC_Logo.svg";
        } else {
          if (
            model !== undefined ||
            model !== null ||
            model.toLowerCase() !== ""
          ) {
            if (model.toLowerCase().includes("continental nx"))
            retVal = "/img/boats/PlaceholderImages/Crest/Continental NX.png";

            // else if (model.toLowerCase().includes("caribbean platinum"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20230711_230-Caribbean-Platinum-SLC-base.png";
            // else if (model.toLowerCase().includes("caribbean rs"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20230711_230-Caribbean-RS-SLC-base.png";
            // else if (model.toLowerCase().includes("classic dlx"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20220817_220-Classic-DLX-SLS-base.png";
            // else if (model.toLowerCase().includes("classic fish"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20220817_220-Classic-Fish-C4-base.png";
            // else if (model.toLowerCase().includes("classic lx"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20220817_base220ClassicLXL.png";
            // else if (model.toLowerCase().includes("classic platinum"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20220817_240-Classic-Platinum-SLS-base.png";
            // else if (model.toLowerCase().includes("caribbean lx"))
            //   retVal = "/img/boats/PlaceholderImages/Crest/20230711_250_Caribbean_LX_SLC_Base.png";

            else if (model.toLowerCase().includes("continental"))
              retVal = "/img/boats/PlaceholderImages/Crest/Continental.png";
            else if (model.toLowerCase().includes("savannah"))
              retVal = "/img/boats/PlaceholderImages/Crest/Savannah.png";
            else
              retVal = "/img/brand/Crest/Crest_StackedLogo_CrestBlue_Web.svg";
          } 
          else 
          {
            retVal = "/img/brand/Crest/Crest_StackedLogo_CrestBlue_Web.svg";
          }
        }
      return retVal;
    },
  },
};
</script>